import type { Task } from "@common/types/task";
import { PresenceStack } from "@components/avatar/PresenceStack";
import { ResolvedViewerUsers } from "@components/presence/TaskViewerUsers";
import { useAgentRunForTask } from "@components/presence/useAgentRunForTask";
import { useTaskRowViewerIds } from "@components/presence/useTaskRowViewerIds";
import { getTaskRowPresenceMembers } from "@components/tasks/board/taskPresenceMembers";

/**
 * A task row's presence stack, after its title: the board card's stack
 * without an assignee who isn't viewing, since the Assignee column shows
 * them. Viewers hide while a task body is open, which shows its own.
 */
export const TaskRowPresence = ({ task }: { task: Task }) => {
    const userIds = useTaskRowViewerIds({
        taskId: task.id,
        workspaceId: task.workspaceId,
    });
    const { isWorking: isAgentWorking } = useAgentRunForTask(task.id);

    return (
        <ResolvedViewerUsers userIds={userIds}>
            {(viewers) => (
                <PresenceStack
                    members={getTaskRowPresenceMembers({
                        isAgentWorking,
                        viewers,
                        assignee: task.assignee ?? null,
                    })}
                />
            )}
        </ResolvedViewerUsers>
    );
};
